import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { countries } from '@/constants/CountryCodes';

interface CountryCodeSelectProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  readOnly?: boolean;
}

const CountryCodeSelect = ({ value, onChange, disabled, readOnly }: CountryCodeSelectProps) => {
  return (
    <div className={readOnly ? 'pointer-events-none' : undefined}>
      <Select value={value} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger
          className={`w-[120px] shrink-0${readOnly ? ' text-sd-muted-foreground' : ''}`}
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent className='bg-sd-popover'>
          {countries.map((c) => (
            <SelectItem key={c.code} value={`+${c.dialCode}`}>
              {c.emoji} (+{c.dialCode})
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default CountryCodeSelect;
